import { memo } from "react"
import { FiltersResponse } from "../config/api"


interface Props {
  selectedFilters: FiltersResponse[],
}
function ActiveFilters({selectedFilters}:Props) {

  if (selectedFilters.every(f => f.values.length === 0)) {
    return null
  }

  return (
    <div className="bg-amber-500/10 rounded-xl p-4 border border-amber-500/20">
      <div className="flex items-center space-x-2">
        <i className="fas fa-filter text-amber-500"></i>
        <span className="text-amber-600 dark:text-amber-400 font-medium">Active Filters:</span>
        <div className="flex flex-wrap gap-2">
          {selectedFilters.map((filter) =>
            filter.values.map((value) => (
              <span key={`${filter.field}-${value}`} className="px-2 py-1 bg-amber-500/20 text-amber-700 dark:text-amber-300 rounded text-xs">
                {value}
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  )
}

export default memo(ActiveFilters)
